// Load of global styles
import './css/global.css';
import './css/themes.css';
import './css/skeleton.css';

// Import single store for all apps
import {store} from '~/store/index';

import './sentry/sentry';

import {REACT_APP_LOADING_EVENT, RenderTriggerEvent} from './types';

window.__BUILD_INFO__ = __BUILD_INFO__;

const renderAppCallback = (event: RenderTriggerEvent) => {
  const {root, AppComponent} = event.detail;

  root.render(<AppComponent store={store} />);
};

document.addEventListener<typeof REACT_APP_LOADING_EVENT>(
  REACT_APP_LOADING_EVENT,
  renderAppCallback
);
